export const LANGS = ["en", "it", "fr", "de", "es", "pl", "pt", "zh", "fa", "ar", "tr"] as const;
export type Lang = (typeof LANGS)[number];
export const HTML_LANG: Record<Lang, string> = {
  en: "en",
  it: "it",
  fr: "fr",
  de: "de",
  es: "es",
  pl: "pl",
  pt: "pt",
  zh: "zh-Hans",
  fa: "fa",
  ar: "ar",
  tr: "tr",
};
export const RTL: ReadonlySet<Lang> = new Set<Lang>(["fa", "ar"]);
export const intlLocale = (lang: string): string =>
  lang === "ar" || lang === "fa" ? `${lang}-u-nu-latn` : lang;
export const prefixOf = (lang: Lang): string => (lang === "en" ? "" : `/${lang}`);

export const UI_STRINGS = [
  "Switch to light mode",
  "Switch to dark mode",
  "Light mode",
  "Dark mode",
  "Enter your name and surname.",
  "You have sent several messages already. Try again later, or use Email us under Contact.",
  "Tick “I'm not a robot”, then press Send.",
  "The security check did not go through. Tick “I'm not a robot” again, then press Send.",
  "The security check could not load. Check your connection, or use Email us under Contact.",
  "Remove the web links from your message, or keep it to two, then press Send again.",
  "Enter an email we can reply to, like name@example.com.",
  "The form is not connected yet. Use Email us under Contact and we will get back to you within 24 hours.",
  "Sending…",
  "Thanks. We will get back to you within 24 hours.",
  "That did not go through. Try again, or use Email us under Contact.",
  "TOTAL VOLUME",
  "AVERAGE FLOW",
  "FLOW",
  "MAIN METER · 3.48 M³/DAY",
] as const;

export type UiString = (typeof UI_STRINGS)[number];

let table: Record<string, string> | null = null;
export function t(s: UiString): string {
  if (!table) {
    table = {};
    try {
      const el = typeof document === "undefined" ? null : document.getElementById("i18n-data");
      if (el?.textContent) table = JSON.parse(el.textContent) as Record<string, string>;
    } catch {
    }
  }
  return table[s] || s;
}

export const pageLang = (): Lang => {
  const tag = typeof document === "undefined" ? "en" : document.documentElement.lang;
  const l = tag.split("-")[0] as Lang;
  return LANGS.includes(l) ? l : "en";
};
